import {NgModule} from '@angular/core';
import {COMPANY_WEAVE_STRUCTURES} from '@infrastructure/http/company-weave-structure/company-weave-structures';
import {HttpCompanyWeaveStructuresService} from '@infrastructure/http/company-weave-structure/http-company-weave-structures.service';
import {FINISHING_TEMPLATES} from '@infrastructure/http/finishing-template/finishing-templates';
import {HttpFinishingTemplatesService} from '@infrastructure/http/finishing-template/http-finishing-templates.service';
import {HttpTextileDataService} from '@infrastructure/http/textile-data/http-textile-data.service';
import {TEXTILE_DATA} from '@infrastructure/http/textile-data/textile-data';
import {HttpWeaveStructuresService} from '@infrastructure/http/weave-structure/http-weave-structures.service';
import {WEAVE_STRUCTURES} from '@infrastructure/http/weave-structure/weave-structures';
import {TextileDataSharedModule} from '@presentation/pages/textile-data/textile-data-shared.module';
import {textileDataRouting} from '@presentation/pages/textile-data/textile-data.routing';
import {AgGridModule} from 'ag-grid-angular';
import {RawMaterialModule} from './raw-material/raw-material.module';

@NgModule({
  imports: [TextileDataSharedModule, textileDataRouting, AgGridModule, RawMaterialModule],
  providers: [
    {provide: TEXTILE_DATA, useClass: HttpTextileDataService},
    {
      provide: FINISHING_TEMPLATES,
      useClass: HttpFinishingTemplatesService
    },
    {provide: WEAVE_STRUCTURES, useClass: HttpWeaveStructuresService},
    {provide: COMPANY_WEAVE_STRUCTURES, useClass: HttpCompanyWeaveStructuresService}
  ]
})
export class TextileDataModule {}
